export class Staff {
    constructor(
        public UserID: string,
        public GivenName: string,
        public GroupDescription: string,
        public Program: string,
        public ServerDescription: string,
        public ServerID: string,
        public Supervisor: boolean,
        public Surname: string,
        public Email: string,
        public Title: string,
        public Phone: string,
        public DisplayName?: string,
        public Initials?: string,
    ) { }
}
